module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3b",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('strong', [_c('em', [_vm._v("Chapter 1")]), _c('br'), _vm._v("Sexual Violation in the Conquest of the Americas")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_c('a', {
    attrs: {
      "id": "ch01a"
    }
  }), _c('strong', [_c('em', [_vm._v("Stephanie Wood")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Underlining the essential link between sexuality and conquest, historian R. C. Padden writes: “Biologically speaking, it was neither microbe nor sword nor mailed fist that conquered Mexico. It was the "), _c('em', [_vm._v("membrus febrilis”")]), _vm._v(" He credits the “love-making” between the “donjuanistas,” who were “in their masculine prime,” and indigenous women with transforming Mexico into a European colony. He suspects that the “Spaniards commonly left more pregnancies in their camps than they did casualties on the field of battle.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not1"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not1"
    }
  }, [_vm._v("1")])]), _vm._v(" Indeed, one conqueror recalled a compatriot who had sired thirty children by indigenous women in only three years."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not2"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not2"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But was that “feverish member” simply engaging in an expression of love or was it also wielded as a weapon of conquest? Could sexual assault, or at least coerced sex, have been a regular feature of early transatlantic “encounters,” beginning with the voyages of Christopher Columbus in the 1490s? Should we not scrutinize the role of sexual domination in warfare and war’s particularly repugnant expression, conquest, before we giddily salute the so-called civilization Europeans introduced into this hemisphere some five hundred years ago?"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not3"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not3"
    }
  }, [_vm._v("3")])]), _vm._v(" Rape has gained notoriety as a feature of conflicts as recent as the wars in Bosnia-Herzegovina and Rwanda and counterinsurgency efforts from Peru to the Middle East. For this reason, a critical examination of the topic has the potential not only for shedding light on the darker side of the Columbian legacy but for illuminating resolutions of social conflict in our modern, crime-ridden societies as we approach the turn of the millennium."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not4"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not4"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("There is no universally accepted definition of the highly charged term “rape,” whether in law or in common usage. Because the topic is so loaded emotionally, “definitional consensus is difficult to attain,” writes Linda Brookover Bourque in her preface to "), _c('em', [_vm._v("Defining Rape."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not5"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not5"
    }
  }, [_vm._v("5")])])]), _vm._v(" She finds a “wide variety of behaviors” that different people will identify as rape. The violence of sexual assault can be expressed in various forms, has a wide range of perceived gravity, and meets with varying degrees of acceptance by both men and women."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not6"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not6"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For the purposes of this essay, which focuses on heterosexual relations, what is important is the possible sexual violation of a woman’s physical and spiritual being, her integrity, dignity, self-possession, power, control, and choice. “Sexual violation” is defined in European terms, owing to our meager knowledge of corresponding concepts among the indigenous populations. Both short- and long-range effects on her person, her family, her community, and her nation are also important. Other issues of concern are the perpetrator’s possible gender chauvinism, racism, classism, religious intolerance, or other forms of cultural prejudice, and the meaning this gives to the colonialism that took shape in the Americas."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not7"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not7"
    }
  }, [_vm._v("7")])]), _vm._v(" The degradation and subjugation of native women by European men may have been part and parcel not only of conquest but of the imposition of a new, multilayered power structure."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not8"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not8"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sexual assault and coercion, all-too-often secret acts, defy quantification, neat historical synthesis, and easy answers. What was the exact nature of the act? What kinds of people committed these acts? At what times and in what kinds of places? What means were used? Why, and how often? Single incidents, which can be shocking and can seem larger than life, do not necessarily clarify the prevalence of sexual violation."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not9"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not9"
    }
  }, [_vm._v("9")])]), _vm._v(" Although we have lately begun to broaden our definition of “text,” the work of historians usually demands some kind of written documentation."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not10"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not10"
    }
  }, [_vm._v("10")])]), _vm._v(" Unfortunately, our sources on sexual assault and coerced sex in the conquest of the Americas are both limited in number and dominated, almost exclusively, by the perspective of the European male."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not11"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not11"
    }
  }, [_vm._v("11")])]), _vm._v(" Lamentably, all too often we have to approach other views, such as that of the indigenous male through the filter of European sources. Even more rarely do we find the perspective of native woman (object of most assaults) in these sources.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dancing around sensitive moral and ethical issues, these records can be fraught with euphemism and metaphor or subterfuge and denial, particularly when directed toward an official or audience of mixed gender. Alternatively, "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("authors also sought to intrigue, impress, and arouse their (typically, male) readers, employing fantasy, invention, exaggeration, bragging, and projection. As Gordon Sayre eloquently discusses elsewhere in this volume, Europeans also saw in Native American sexuality what they wanted to see.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The following account, left by Michele de Cuneo, an Italian noble on Columbus’s second voyage to the Caribbean, is extremely rare for its detail and clarity:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("While I was in the boat, I captured a very beautiful Carib woman, whom the said Lord Admiral [Columbus] gave to me. When I had taken her to my cabin she was naked—as was their custom. I was filled with my desire to take my pleasure with her and attempted to satisfy my desire. She was unwilling, and so treated me with her nails that I wished I had never begun. But—to cut a long story short—I then took a piece of rope and whipped her soundly, and she let forth such incredible screams that you would not have believed your ears. Eventually we came to such terms, I assure you, that you would have thought she had been brought up in a school for whores.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cuneo twists the rape into a scene of seduction, titillating his European male audience back home, knowing full well that the “Carib” woman’s version of events would never come to the fore."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not12"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not12"
    }
  }, [_vm._v("12")])]), _vm._v(" Her resistance—overcome—is central to the message of his own sexual prowess, and such resistance was apparently not unusual in the Caribbean experience.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Examples of women’s particular resistance and fear provide important "), _c('em', [_vm._v("indirect")]), _vm._v(" evidence of sexual violation. On one of Columbus’s voyages, ten women who had been captured and taken aboard ship jumped overboard at one point and tried to swim the half-league to safety on the island of Hispaniola (modern-day Haiti and the Dominican Republic)."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not13"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not13"
    }
  }, [_vm._v("13")])]), _vm._v(" In another incident, Cuneo reports that when Spanish conquerors released some surplus female slaves on the same island, they “left their infants anywhere on the ground and started to flee like desperate people.” The scene suggests a considerable feeling of urgency on the part of the women to put distance between themselves and the Spaniards. Cuneo reported that some ran eight days “beyond mountains and across huge rivers.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not14"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not14"
    }
  }, [_vm._v("14")])]), _vm._v(" If the story is true, the infants could have been the product of sexual assault at the time of capture or in the ensuing captivity period, and the women may have figured that the Spanish fathers should claim the infants and care for them, not wanting the sad burden themselves."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not15"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not15"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("We know from the experience at the first settlement Columbus left behind on Hispaniola, La Navidad, that the European men were coercing sexual relations with the local women. As one European of the period, Guillermo Coma, put it, “Bad feeling arose and broke out into warfare because of the licentious conduct of our men towards the Indian women, for each Spaniard had five women to minister to his pleasure,” and “the husbands and relatives of the women, unable to take this, banded together to avenge this insult and eliminate this outrage.” Columbus found the fort destroyed and all the men he had left behind dead when he returned on his second voyage."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not16"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not16"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While Christopher Columbus regularly remarked about Caribbean women’s nakedness, launching what has become a long tradition we might call ethnographic voyeurism,"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not17"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not17"
    }
  }, [_vm._v("17")])]), _vm._v(" his reports were fairly matter-of-fact and aimed at an official audience. In contrast, his contemporary Amerigo Vespucci felt free to elaborate a more literary image, loaded with sexual hyperbole."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not18"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not18"
    }
  }, [_vm._v("18")])]), _vm._v(" Whereas other records remind us that “the women of the islands seem … to have been naturally resistant to European advances,” Vespucci’s accounts emphasize the women’s sexual liberality and exaggerated lust, continuing a legend-making tradition launched at least as early as the reconquest of Spain, in descriptions of Moorish women."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not19"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not19"
    }
  }, [_vm._v("19")])]), _vm._v(" He teases his male audiences with stories such as the one that made him famous, about how sexually voracious women encouraged venomous animals (insects?) to bite their indigenous mates’ penises, enlarging them, apparently for the women’s satisfaction but to the point that many men would “lose their virile organ and remain eunuchs.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not20"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not20"
    }
  }, [_vm._v("20")])]), _vm._v(" The scene was thereby set for Europeans to take the native men’s places and become the object of erotic tortures (and take control of the island, to boot) because, the story goes, the women were so fond of “Christians” that “they debauch and prostitute themselves.” Still, European men were to proceed cautiously, for Vespucci reminds them of one man who complacently received the attentions of a group of indigenous women while another bludgeoned him from behind."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not21"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not21"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gonzalo Fernández de Oviedo remarked several times on the sensuality of indigenous women on Hispaniola. He continued to build the myth of their preference for European men over their own. Like Vespucci, he recounts an episode with a subtext of arousal: “an Indian woman took a bachelor called Herrera, who had fallen behind his companions and was left alone with her, and seized him by the genitals and made him very tired and exhausted.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not22"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not22"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0013-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_vm._v("Figure 1.1. European depiction of a scene described by Amerigo Vespucci, in which an indigenous woman prepares to bludgeon a Spaniard in the Caribbean. Line-drawing copy by Gabriela Quiñones of a scene in the "), _c('em', [_vm._v("Quatuor navigationes")]), _vm._v(" (1509), as published in Tzvetan Todorov, "), _c('em', [_vm._v("The Morals of History")]), _vm._v(" (Minneapolis: University of Minnesota Press, 1995), 111.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Notwithstanding the fantasy of sexual paradise that European writers were forging, and the suggestions of coercion and resistance that sometimes temper it, we must also allow the possibility that indigenous cultures did have different perspectives on sex. According to Ramón Gutiérrez, among the precontact Pueblo peoples of what is now New Mexico, the women, especially, found sexual intercourse an activity of considerable “cultural import” and “essential for the peaceful continuation of life.” He says these “libidinous” women were “empowered through their sexuality,” which was “theirs to give and withhold.” They did extend it to outsiders, but often expected “blankets, meat, salt, and hides” in return, or some “bond of obligation.” Thus, when the Spanish “soldiers satisfied their lust with Indian women but gave nothing in return, the Indian men declared war.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not23"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not23"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("The women’s willingness—possibly expressed under certain circumstances—vanished when confronted with the Spaniards’ insatiable demands and failure to reciprocate. Neither a playful, intimate exchange nor the satisfaction of a biological need were the Spanish men’s sole objectives; it seems, rather, that some or many saw sexual subjugation as an inherent feature of political and economic conquest."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not24"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not24"
    }
  }, [_vm._v("24")])]), _vm._v(" During an investigation made in 1601 into the conquest of the Pueblos of 1598, Franciscan friar Francisco Zamora testified, “I know for certain that the soldiers have violated them [the women] often along the roads.” Fray Joseph Manuel de Equía y Leronbe reported overhearing conquerors shouting: “Let us go to the pueblos to fornicate with the Indian women. … Only with lascivious treatment are Indian women conquered.” But in this investigation the conquerors would not admit to assault, again insisting that the indigenous women were licentious and lustful and that their men did not care about faithfulness."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not25"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not25"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In early Brazil, European men also rhapsodized about a land of insatiable, sexually welcoming native women. Jean de Parmentier reported that the young women of Brazil, given as gifts by their fathers to the Europeans, were like “colts who have never experienced a rein.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not26"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not26"
    }
  }, [_vm._v("26")])]), _vm._v(" The reading of this metaphor is ambiguous: were they playful and frisky, or were they frightened and resisting, requiring that they be broken? Virgins, too, could be seen as needing to be “broken in,” another element in male fantasy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pero Vaz de Caminha, a Portuguese invader of the early sixteenth century, went into raptures about the local Brazilian women’s “privy parts” (described in intimate detail) and how, “even when we examined them very closely, they did not become embarrassed.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not27"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not27"
    }
  }, [_vm._v("27")])]), _vm._v(" His mention of embarrassment is a clue that he, at least, felt this close examination was a kind of violation, or would have been if it had been conducted on European women. Were these indigenous women, in contrast, some kind of “other” against whom such abuses were freely committed?"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not28"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not28"
    }
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another report from early Brazil tells how the women “have little resistance against those who assault them. In fact, instead of resisting, they go and seek them out in their houses.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not29"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not29"
    }
  }, [_vm._v("29")])]), _vm._v(" But the phrase “those who assault them” raises a red flag. Is this an age-old example of the blame-the-victim mentality that claims “she asked for it?”’ Perhaps what some indigenous women sought was "), _c('em', [_vm._v("peaceful")]), _vm._v(" sexual intercourse with "), _c('em', [_vm._v("some")]), _vm._v(" of these Europeans in Brazil, hoping to derive a benefit from it. Jean de Léry, a French Protestant pastor traveling among the Tupinambá in the 1550s, "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("said that the women “drove us crazy by following us about continually, saying, ‘Frenchman, you are good, give me some of your bracelets or glass beads!’”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not30"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not30"
    }
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When modern historian Magnus Mörner notes that prematrimonial virginity was not prized by all tribes and from this concludes that “Indian women very often docilely complied with the conquistadores’ desires,” the leap seems considerable."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not31"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not31"
    }
  }, [_vm._v("31")])]), _vm._v(" If assault or coercion were regular features of early exchanges, particularly in conquest settings, we must not underestimate the native women’s probable repulsion and fear on such initial meetings. We must make a greater effort to distinguish sexual violation from consensual intercourse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ecclesiastical chroniclers were more likely than other European men on the scene to make this distinction, and to make complaints about coerced sex."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not32"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not32"
    }
  }, [_vm._v("32")])]), _vm._v(" It was the clergy’s role to help reassert order and control during the Counter-Reformation and as the Iberian empire rapidly expanded and became more heterogeneous than ever."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not33"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not33"
    }
  }, [_vm._v("33")])]), _vm._v(" Just as Franciscans protested abuses in New Mexico, their counterparts in California also complained regularly about the men of the presidios “molesting” the indigenous women."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not34"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not34"
    }
  }, [_vm._v("34")])]), _vm._v(" In the mid-sixteenth-century conquest of Venezuela, Fray Pedro de Aguado charged that mixed-heritage recruits were imitating the Spanish, daring to “fornicate with the (Indian women) so shamelessly … because in front of the Indians themselves, husbands and fathers, they perpetrated this evil.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not35"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not35"
    }
  }, [_vm._v("35")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the Chilean frontier the clergy also denounced abuses committed by resentful men stationed at distant outposts among the Araucanians. But it was a secular chronicler who reported that in “one encampment where there were soldiers recently arrived from Spain, together with others whom the maestre de campo had under his command,” during a single week sixty women gave birth to “illegitimate” babies of mixed heritage. Many women had been “carried off … for [these] more shameful purposes,” creating a “deep-seated spirit of rebellion.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not36"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not36"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Note the use of the adjective “shameful” even by a lay observer. By the early sixteenth century, European art indicates a growing repugnance for the act of rape, which, in medieval times, had often been seen as “heroic” and was generally “sanitized or eroticized,” according to Diane Wolfthal. Economic crises in the 1480s and resulting migrations of rural poor to the cities frightened the urban middle class which responded by “formalizing and tightening up social control,” probably contributing to these changing attitudes. While a few artists had occasionally shown some sympathy "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("for the rape victim, the trend became one in which she was made into a woman of loose morals, responsible for her own fate."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not37"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not37"
    }
  }, [_vm._v("37")])]), _vm._v(" These multiple views of sexual violence could have been influencing behaviors and attitudes expressed in the Iberian colonies of the Americas, entities emerging at precisely the time of the shift Wolfthal identifies in European art.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Those who felt concerned to establish permanent settlements and replicate European institutions of church and government were probably more likely to censure sexual assault and the protracted, coercive sex exacted from female slaves and servants. It can be hypothesized that greater offenses were committed with higher frequency earlier in the conquest phase and farther from center of society. In such settings, justice was more likely to be suspended, due to the relatively light representation of officials and courts and the weak, distant pull of social mores.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Frontier behaviors, which lasted into the nineteenth century in many parts of Latin America and the United States, were not terribly different from those of the conquest period in the more densely populated central areas, such as highland Mexico of the sixteenth century."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not38"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not38"
    }
  }, [_vm._v("38")])]), _vm._v(" Bartolomé de las Casas, a conqueror-turned-priest who freed his indigenous slaves and began speaking out against the abuses of conquest, wrote a book (published in 1552) in which, among other things, he recalls an attempted rape in Jalisco, Mexico, in which a Spanish conqueror “took a maiden by force to commit the sin of the flesh with her, dragging her away from her mother, finally having to unsheathe his sword to cut off the woman’s hands and when the damsel still resisted they [the conqueror’s companions] stabbed her to death.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not39"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not39"
    }
  }, [_vm._v("39")])]), _vm._v(" While rival Europeans anxious to discredit the Spanish style of colonization devoured Las Casas’s accounts, forging the Black Legend, we cannot ignore his sometimes detailed descriptions, particularly when less inflammatory records largely substantiate this kind of activity in the conquest era."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not40"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not40"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bernal Díaz, a conqueror of Mexico, recalled how the men’s primary concern after breaking “enemy ranks” had been “to look for a pretty woman or find some spoil.” He also spoke of women as synonymous with spoil, noting how a Captain Sandoval brought to Texcoco “much spoil, especially of good-looking Indian women” from the conquest of another part of Mexico."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not41"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not41"
    }
  }, [_vm._v("41")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Conquerors did not simply ravish women on the roads or in the fields; they increasingly seized them for long-term domestic service. These women would heal the conquerors of their battle wounds and gather and prepare food for them and their horses, eventually settling down into a "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("domestic relationship in which they had to perform all kinds of duties, including sexual ones. Here, the nature of sexual relations probably varied along a continuum between assault and mutual agreement. One can imagine that some women resisted and continually faced assault; some became resigned and gave in to their powerful masters’ demands, possibly still finding subtle ways to resist or take revenge; some came to accept the relationship as a form of marriage or concubinage, possibly striving to make it work to their advantage in some way; and others possibly welcomed the new unions. It is noteworthy, however, that protests about these long-term relationships continued to issue from both Spanish and indigenous observers on the scene."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not42"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not42"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In choosing the candidates for this form of servitude, some conquerors may have been guided by their racism to seek out fair-skinned indigenous women. In the Florentine Codex, containing rare indigenous testimonies of the Conquest, citizens of Mexico City told how, after the capital fell, the Spaniards “took, picked out the beautiful women, with yellow bodies. And how some women got loose was that they covered their faces with mud and put on ragged blouses and skirts.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not43"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not43"
    }
  }, [_vm._v("43")])]), _vm._v(" If the men looked upon their captive women as “beautiful,” perhaps they tried to develop romantic views toward them, something that might have brought some affection and romance to the sexual relationship. But Cortés periodically ordered, coldly, that these commoner women, who were seized during the various expeditions of the Conquest, be branded and auctioned off, with one-fifth of the proceeds going to the crown and one-fifth to him. Some of Cortés’s men allowed a few of the “sound and handsome Indian women” to escape these proceedings and then later hired them “as free servants,” probably hoping to avoid the stiffer tax yet still have access to these women."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not44"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not44"
    }
  }, [_vm._v("44")])]), _vm._v(" So, even when viewed as beautiful, these slave or servant women enjoyed little or no power in their relationships with the Spanish invaders and probably many had to endure regular unwanted sexual advances.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That sex was a clear expectation from the men’s perspective is reflected in their concern to capture virgins. In the Ajusco manuscript, another one of the exceptional records made by indigenous males about the Spanish conquest of Mexico, we learn, “It is known how [the Spaniards] take away [the indigenous rulers’] pretty women and also their women [who are] girls, virgins.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not45"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not45"
    }
  }, [_vm._v("45")])]), _vm._v(" In certain passages Bernal Díaz also emphasizes the women’s virginity (while simultaneously conveying his racist impression that indigenous women, in general, were not attractive), as when he recounts "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("a gift of “five beautiful Indian maidens, all virgins. They were very handsome for Indian women.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not46"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not46"
    }
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0018-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_vm._v("Figure 1.2. Indigenous pictorial showing women of Tlaxcala, Mexico, presented to Spanish conquerors as gifts. Line-drawing copy by Gabriela Quiñones of a scene in the "), _c('em', [_vm._v("Lienzo de Tlaxcala,")]), _vm._v(" as published in Luis Reyes García, "), _c('em', [_vm._v("La escritura pictográfica en Tlaxcala: Dos mil años de experiencia mesoamericana,")]), _vm._v(" Colección Historia de Tlaxcala, no. 1 (Tlaxcala, Mexico: Universidad Autónoma de Tlaxcala, 1993), 280.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The gift to which he refers exemplified the many exchanges that solidified alliances between indigenous communities and the Spanish conquerors of Mexico. The famous “La Malinche,” or doña Marina, was one of twenty women given to Cortés in Tabasco in 1519, along with presents of gold and handwoven clothing, as symbols of peace. (The people of Tabasco had attacked the Spaniards three times but were finally capitulating.) Through baptism, Bernal Díaz recalls, these twenty became “the first women in New Spain to become Christians,” and Cortés quickly distributed them to his captains, just as Columbus had done in the Caribbean a generation before him. Doña Marina eventually became a hardworking interpreter for Cortés and had a child by him."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not47"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not47"
    }
  }, [_vm._v("47")])]), _vm._v(" Although later in Mexican history she appears as a traitor to indigenous peoples, Frances Karttunen points out that “she had no people and nowhere to flee. Her best hope for survival was to accept whatever situation was assigned to her and to try to make herself useful and agreeable.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not48"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not48"
    }
  }, [_vm._v("48")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("One elite indigenous male perspective on the presentation of such gifts of women to the Spaniards can be detected in the chapter where Díaz discusses another “eight Indian girls,” this time from Cempoala, who were also baptized and taken away by Cortés and seven of his men. The "), _c('em', [_vm._v("caciques,")]), _vm._v(" or chieftains, reportedly “told Cortés that as we were now their friends they would like to have us for brothers and to give us their daughters to bear us children.” This statement, filtered through Díaz, quietly underlines the sexual and maternal role both sides apparently expected of the women. With their daughters (and subsequent grandchildren) in the European camp, both sides knew that this group of chiefs would not be sending their warriors to attack the Spaniards. Perhaps the women would also be expected to help influence the foreign invaders to maintain peace with their hometowns. The same caciques, Díaz claims, “were very well disposed towards us from that time forward, and particularly so when they saw that Cortés accepted their daughters.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not49"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not49"
    }
  }, [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0019-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_vm._v("Figure 1.3. Indigenous pictorial showing elite maidens being removed from the city at about the time of the arrival of conqueror Hernando Cortés to Mexico-Tenochtitlan. Line-drawing copy by Gabriela Quiñones of the "), _c('em', [_vm._v("Azcatitlan Annals,")]), _vm._v(" as published in Gordon Brotherston, "), _c('em', [_vm._v("Painted Books from Mexico: Codices in the UK Collections and the World They Represent")]), _vm._v(" (London: British Museum Press, 1995), 60 (plate 57).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("If we had more direct testimony from the caciques, we might find that some saw the gifts of women as a necessary but reluctant sacrifice. The Ajusco document reads: “It is prudent that we give ourselves to the men of Castile, to see if that way they do not kill us.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not50"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not50"
    }
  }, [_vm._v("50")])]), _vm._v(" To reduce sexual assault and possibly avoid putting themselves in this kind of dilemma about having to offer women as gifts, some communities helped the women hide from the approaching conquerors. In one indigenous city in Michoacán, Mexico, the Spaniards found that “there were no women in the city, all of them having run away.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not51"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not51"
    }
  }, [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Returning to the example of the Cempoalan women given as gifts to Cortés’s group, we note an additional feature worthy of comment. These women came with both golden jewelry and their own maids, and the one with the highest status was a “mistress of towns and vassals.” The generosity of this gift, according to Díaz, brought a “gracious smile” to Cortés’s lips."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not52"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not52"
    }
  }, [_vm._v("52")])]), _vm._v(" These kinds of alliances gave the conquerors more than virtual wives. They sometimes brought the men wealth and power in the form of royal grants called "), _c('em', [_vm._v("encomiendas,")]), _vm._v(" or trusteeships over communities from which they could extract tribute in goods and labor. Many a conqueror hotly pursued these matches with the indigenous “ladies,” or noblewomen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Similarly, in Peru, writes historian Steve Stern, “To the Spanish elites, marriage to native women from influential or wealthy families brought social connections and dowries.” He adds, “Spanish individuals and power groups … enhanced their authority and economic potential by cultivating a clientele of Indian allies and functionaries.” For the indigenous peoples, these alliances brought protection and advancement."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not53"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not53"
    }
  }, [_vm._v("53")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In Brazil, the native men “wanted [the foreigner] to be surrounded by their women,” according to John Hemming, because they were “godlike figures who easily qualified for the many wives befitting their rank.” He repeats the sixteenth-century European claim that the “women were ready partners,” adding that “in the early days their men acquiesced because it was hospitable to offer women to strangers.” He reports how one indigenous chief supposedly said that in early times the Europeans “freely slept with our daughters, which our women … considered a great honour.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not54"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not54"
    }
  }, [_vm._v("54")])]), _vm._v(" These attitudes changed over time, as in New Mexico, when it became obvious that the invaders did not really behave as gods and did not "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("regularly return the hospitality and honor some individuals tried to show them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In most of these scenarios—of alliances being cemented on the backs of young indigenous women—the women appear as pawns without a voice, which is not only a commentary on the emerging colonial system but also reveals a possibly unequal gender dynamic within the indigenous societies themselves. The European interpreters, at least, saw the young women as the property of their indigenous fathers, to be distributed to the foreigners in these arrangements as the fathers saw fit. Even in the indigenous records, where the more forceful taking of the women by Spaniards is lamented upon occasion, the women’s own testimonies are grievously lacking."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not55"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not55"
    }
  }, [_vm._v("55")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A desire to strengthen their own wealth or status may have guided the Aztec women who were allegedly reluctant to return to their own people after being kidnaped by Spanish conquerors toward the end of the siege on Mexico City. Perhaps they saw the Spanish victory as inevitable. Perhaps there was some aspect of their new lives with the Europeans that appealed to them more than their old. If, like doña Marina, they had been slaves in the indigenous world, they may have had no homes to return to. At any rate, according to Bernal Díaz, when Cortés ordered that the daughters and wives of the elite be returned to their families, “there were many who did not wish to go … but preferred to remain with the soldiers with whom they were living. Some hid themselves, others said they did not wish to return to idolatry, and yet others were already pregnant.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not56"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not56"
    }
  }, [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With the pending arrival of a child, one can imagine that the indigenous female attached for some time to a conqueror, whether as gift, hired servant, or slave, might adjust her view of the relationship. She might make concessions in order to secure a better future for her child. Some conquerors did provide for the offspring they produced with indigenous women, if not in a way that was equal to their provision for their “legitimate” heirs."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not57"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not57"
    }
  }, [_vm._v("57")])]), _vm._v(" One conqueror of sixteenth-century Paraguay sired children with seven different indigenous women, six of whom were his own “servants,” but he assisted the daughters of these unions, giving them dowries substantial enough to enable them to marry other Spanish conquerors."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not58"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not58"
    }
  }, [_vm._v("58")])]), _vm._v(" In 1530, a Pedro de Vadillo left large monetary bequests in his will for the dowries of several indigenous women in his West Indian household and one "), _c('em', [_vm._v("mestizo")]), _vm._v(" (mixed-heritage) woman (his offspring?), plus money for a “bastard” (probably mestizo) nephew, for “food, clothing, books, and education for ten years, so that he may become a lawyer.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not59"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not59"
    }
  }, [_vm._v("59")])])]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("Figure 1.4. Indigenous depiction of a struggle in colonial Peru between a Spanish conqueror and an indigenous man over possession of the latter’s daughter. Line-drawing copy by Gabriela Quiñones from a leaf of the "), _c('em', [_vm._v("Nueva crónica y buen gobierno")]), _vm._v(" of 1615, as published in Steve J. Stern, "), _c('em', [_vm._v("Peru’s Indian Peoples and the Challenge of Spanish Conquest: Huamanga to 1640")]), _vm._v(" (Madison: University of Wisconsin Press, 1982), 172.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0022-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("Just as pregnancy largely “served to move the story line forward” in Greek mythology about rape,"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not60"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not60"
    }
  }, [_vm._v("60")])]), _vm._v(" "), _c('em', [_vm._v("mestizaje")]), _vm._v(" (the production of mixed offspring) has captured the attention of some modern historians who may be uncomfortable studying the role of sexual violation in conquest and in the evolving colonies. Even people of the conquest era preferred to focus on the offspring rather than the method of conception. Francisco de Aguirre, governor of Tucumán, pronounced that “the service rendered to God in producing mestizos is greater than the sin committed by the same act.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not61"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not61"
    }
  }, [_vm._v("61")])]), _vm._v(" This story line also appeals, understandably, to the modern descendants of the Spanish, Portuguese, indigenous, and African actors on the stage of conquest and colonization, descendants who now proudly point to their roots in two or more ancient civilizations. It is not easy to consider oneself a descendant of the “hijo de la chingada” (child of the violated woman)."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not62"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not62"
    }
  }, [_vm._v("62")])]), _vm._v(" The famous independence hero, Simón Bolívar, remarked acidly on this heritage of violation in order to stir emotions against colonialism: “The most impure origin is that of our being: all that has preceded us is wrapped with the black veil of the crime.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not63"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not63"
    }
  }, [_vm._v("63")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The English, long-time rivals of the Spanish, relished making comparisons between the colonial practices of these two imperialist powers. Sir Walter Ralegh wrote, for example,"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not64"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not64"
    }
  }, [_vm._v("64")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("“I neither know nor beleeve, that any of our company … by violence or otherwise, ever knew any of their [the indigenous men’s] women. … I suffered not any man … so much as to offer to touch any of their wives or daughters: which course so contrary to the Spaniards … drewe them to admire her Majestie [Queen Elizabeth], whose commaundement I tolde them it was.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Defenders of the Iberian conquerors will admit apologetically that some may have “known” indigenous women “by violence,” but they showed less racism toward Native American women in their willingness (and eagerness in the case of elite women) to form lasting unions and raise families with them. English-American males, in contrast, with a different background and distinct colonial goals, largely shunned indigenous women.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The national-character angle has long been a favorite, for better or worse, in comparisons of colonial situations across the hemisphere. More aptly approached when viewed as a study of cause and effect rather than "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("a process assigning moral blame for the perceived flaws of some stereotyped ethnic personality, this methodology may have validity for examining Iberian patriarchy and its significance for patterns of sexual violation. The strongly patriarchal nature of Spanish and Portuguese societies could have affected gender power relations to the extent that sexual licentiousness was both a greater likelihood in conquest and a serious concern after colonization, when wives and daughters needed “protection.” In sixteenth-century Spain, men wanted to enjoy their own “sexual privilege” but also sought to “protect the chastity” of women in their families. Still, it was women, not men, who were viewed as sexually dangerous. Sources indicate that women, in general, were thought to have the power to “lead men’s souls to hell,” and therefore required control."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not65"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not65"
    }
  }, [_vm._v("65")])]), _vm._v(" In the so-called Justice paintings of Renaissance art, in which rape comes to be condemned but attributed to the woman’s seductiveness and willingness, male behavior was excused, in much the same way that actual accused rapists tried to exculpate themselves, when they went before judges, by throwing blame on the victim."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not66"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not66"
    }
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The circumstances of war, in the men’s view, could provide further justification for their behavior. The view of sexual violation as a privilege of conquest in the Americas probably had roots in medieval Europe, where “to rape and loot were among the few advantages open” to foot soldiers, according to Susan Brownmiller."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not67"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not67"
    }
  }, [_vm._v("67")])]), _vm._v(" In the main, the Spanish conquerors in this hemisphere were not trained, salaried soldiers in whose wake would follow civilian society; the conquerors would form the core of first settlers. They were investors in each expedition of “discovery” and conquest, called an "), _c('em', [_vm._v("entrada,")]), _vm._v(" and many would fight, expecting material rewards that would correspond to their investment and service."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not68"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not68"
    }
  }, [_vm._v("68")])]), _vm._v(" As we have seen, women slaves and servants formed a part of the “reward” system.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The common fighter, if lucky, might receive a lump sum, from the captains’ investment pool, with which to outfit himself. After that, booty was probably his principal payment."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not69"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not69"
    }
  }, [_vm._v("69")])]), _vm._v(" This booty, or spoil, included indigenous women. Similarly, even when permanent settlement was not the objective, there was another form of enterprise engaged in by Iberians, especially the Portuguese, called "), _c('em', [_vm._v("rescate")]), _vm._v(" or "), _c('em', [_vm._v("resgate,")]), _vm._v(" which originated as “trading at an advantage” but evolved into the “direct taking of Indian slaves.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not70"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not70"
    }
  }, [_vm._v("70")])]), _vm._v(" Often, again, these were indigenous women. We must remember, too, how the soldiers of both entradas and rescate enterprises saw the indigenous peoples as members of an “inferior race” of “savages.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not71"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not71"
    }
  }, [_vm._v("71")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("While the cultural, social, political, and economic context may have been ripe for sexual violation in Spanish and Portuguese conquest expeditions, it remains to be explored whether it was a conscious tool. The monarchs often advocated a race-conscious, biologically defined policy of “miscegenation,”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not72"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not72"
    }
  }, [_vm._v("72")])]), _vm._v(" but nowhere did they recommend abuses, and, in fact, they legislated against them."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not73"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not73"
    }
  }, [_vm._v("73")])]), _vm._v(" Nor did leaders such as Christopher Columbus, Hernando Cortés, and Francisco Pizarro specify rape as a military strategy in any known written records, although they personally distributed indigenous women to their captains, surely knowing that the men were forcing themselves upon their captives. The leaders must also have watched (if they did not participate in) the ravishment of women in their sieges of communities, yet were more likely to speak out against other abuses, such as the trading of worthless European trinkets for gold nuggets."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not74"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not74"
    }
  }, [_vm._v("74")])]), _vm._v(" This, coupled with their silence upon witnessing the destructive retaliation their “sensual debauchery” could bring (in the words of a Jesuit in Brazil),"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not75"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not75"
    }
  }, [_vm._v("75")])]), _vm._v(" and the prolongation of conflict that postponed effective settlement and complicated trade, leads one to suspect that sexual assault had become at least a spontaneous tactic and sometimes a conscious strategy."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not76"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not76"
    }
  }, [_vm._v("76")])]), _vm._v(" Europeans could have viewed rape apologetically as a necessary “release” that followed on the heels of battle. More cynically, it may have also represented the striking of a relatively easier target in the heat of a contest, and an indirect hit aimed not only at women but at their male partners and relatives and the integrity of native society as a whole. Finally, unwanted European advances against indigenous women could have served to pick the fight that would lead to a “just war,” a full-scale invasion and occupation of indigenous territory, and an excuse for enslaving (and subsequently controlling in various other ways) the labor force on a more permanent basis."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not77"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not77"
    }
  }, [_vm._v("77")])]), _vm._v(" The "), _c('em', [_vm._v("membrus febrilis,")]), _vm._v(" alongside sword and microbe, was indeed a deadly implement of war."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01not78"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ich01not78"
    }
  }, [_vm._v("78")])])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NOTES")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A shorter version of this essay appeared in 1992 as “Rape as a Tool of Conquest in Early Latin America,” in the "), _c('em', [_vm._v("CSWS Review")]), _vm._v(" of the Center for the Study of Women in Society, University of Oregon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not1"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not1"
    }
  }, [_vm._v("1")]), _vm._v(". R. C. Padden, "), _c('em', [_vm._v("The Hummingbird and the Hawk: Conquest and Sovereignty in the Valley of Mexico, 1503–1541")]), _vm._v(" (Columbus: Ohio State University Press, 1967), 229–31. He interprets this behavior as an emulation of the indigenous lords, deflecting any blame away from European culture. He also calls the "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("conquest “amorous.” And, lest we mistake the conqueror for a rapist, he reminds us, “She sought that exquisite pain as avidly as He, and beneath the enveloping Christian heaven She also found guilt.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not2"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not2"
    }
  }, [_vm._v("2")]), _vm._v(". Ricardo Herren, "), _c('em', [_vm._v("La conquista erótica de las Indias")]), _vm._v(" (Barcelona: Planeta, 1991), 12.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not3"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not3"
    }
  }, [_vm._v("3")]), _vm._v(". Tzvetan Todorov captures the repugnant aspects of colonialism as “humiliation, shameless exploitation, and loss of liberty.” "), _c('em', [_vm._v("The Morals of History")]), _vm._v(" (Minneapolis: University of Minnesota Press, 1995), 53–54. This is especially true of a colonialism imposed on an already inhabited land through conquest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not4"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not4"
    }
  }, [_vm._v("4")]), _vm._v(". On the Bosnian conflict, see "), _c('em', [_vm._v("Mass Rape: The War against Women in Bosnia-Herzegovina,")]), _vm._v(" edited by Alexandra Stiglmayer (Lincoln: University of Nebraska Press, 1994). On Rwanda, see James C. McKinley, Jr., “The Legacy of Rwanda Violence,” "), _c('em', [_vm._v("New York Times,")]), _vm._v(" September 23, 1996, A1:2. On rape as a tool of counterinsurgency in Peru, see the discussion of an "), _c('em', [_vm._v("Americas Watch Report")]), _vm._v(" in the "), _c('em', [_vm._v("New York Times,")]), _vm._v(" April 29, 1993, A4:3; in Argentina, see "), _c('em', [_vm._v("Nunca más: informe de la Comisión Nacional sobre la Desaparición de Personas")]), _vm._v(" (Buenos Aires: EUDEBA, 1994); and, in general, see the discussion of an Amnesty International report in "), _c('em', [_vm._v("The Middle East")]), _vm._v(" 210 (April 1992): 5–11.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not5"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not5"
    }
  }, [_vm._v("5")]), _vm._v(". Linda Brookover Bourque, "), _c('em', [_vm._v("Defining Rape")]), _vm._v(" (Durham, N.C.: Duke University Press, 1989), xv.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not6"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not6"
    }
  }, [_vm._v("6")]), _vm._v(". Bourque, "), _c('em', [_vm._v("Defining Rape,")]), _vm._v(" 286–91.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not7"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not7"
    }
  }, [_vm._v("7")]), _vm._v(". Albert L. Hurtado lists all these forms of chauvinism with the exception of sexism, which he recognizes implicitly. "), _c('em', [_vm._v("Indian Survival on the California Frontier")]), _vm._v(" (New Haven: Yale University Press, 1988), 185.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not8"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not8"
    }
  }, [_vm._v("8")]), _vm._v(". Elinor Burkett has astutely observed that “the rape of indigenous women must be seen as a type of violent behavior intended to subjugate and oppress.” “Indian Women and White Society: The Case of Sixteenth-Century Peru,” in "), _c('em', [_vm._v("Latin American Women: Historical Perspectives,")]), _vm._v(" edited by Asunción Lavrin (Westport, Conn.: Greenwood Press, 1978), 128.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not9"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not9"
    }
  }, [_vm._v("9")]), _vm._v(". See Bourque, "), _c('em', [_vm._v("Defining Rape,")]), _vm._v(" 296, for a reference to prevalence and incidence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not10"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not10"
    }
  }, [_vm._v("10")]), _vm._v(". See Gordon Brotherston’s discussion of American Indian literature in "), _c('em', [_vm._v("Image of the New World: The American Continent Portrayed in Native Texts")]), _vm._v(" (London: Thames and Hudson, 1979), 15–18; and Elizabeth Boone’s introduction to "), _c('em', [_vm._v("Writing without Words: Alternative Literacies in Mesoamerica and the Andes,")]), _vm._v(" edited by Elizabeth Hill Boone and Walter Mignolo (Durham, N.C.: Duke University Press, 1994).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not11"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not11"
    }
  }, [_vm._v("11")]), _vm._v(". I sympathize with Louis Montrose’s concern “that the trajectory of this essay courts the danger of reproducing what it purports to analyze: namely, the appropriation and effacement of the experience of both native Americans and women by the dominant discourse of European patriarchy.” “The Work of Gender in the Discourse of Discovery,” in "), _c('em', [_vm._v("New World Encounters,")]), _vm._v(" edited by Stephen "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v("Greenblatt (Berkeley: University of California Press, 1993), 179. But I will also critique those sources and attempt to bring to light indigenous perspectives at every possible turn.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not12"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not12"
    }
  }, [_vm._v("12")]), _vm._v(". J. M. Cohen, "), _c('em', [_vm._v("The Four Voyages of Christopher Columbus: Being His Own Log-Book, Letters and Dispatches with Connecting Narrative Drawn from the Life of the Admiral by His Son Hernando Colón and Other Contemporary Historians")]), _vm._v(" (Harmondsworth, England: Penguin, 1969), 139. Cuneo may have called this woman a Carib with the intended meaning of “hostile Indian”; some Taínos were misrepresented this way, both intentionally and unintentionally. See Irving Rouse, "), _c('em', [_vm._v("The Tainos: Rise and Decline of the People Who Greeted Columbus")]), _vm._v(" (New Haven: Yale University Press, 1992), 146; and Kirkpatrick Sale, "), _c('em', [_vm._v("The Conquest of Paradise: Christopher Columbus and the Columbian Legacy")]), _vm._v(" (New York: Penguin, 1991), 130.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not13"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not13"
    }
  }, [_vm._v("13")]), _vm._v(". Hans Koning, "), _c('em', [_vm._v("Columbus: His Enterprise")]), _vm._v(" (New York: Monthly Review Press, 1976), 77.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not14"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not14"
    }
  }, [_vm._v("14")]), _vm._v(". Sale, "), _c('em', [_vm._v("The Conquest of Paradise,")]), _vm._v(" 138.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not15"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not15"
    }
  }, [_vm._v("15")]), _vm._v(". The thousands of offspring that resulted from rapes in the war in Rwanda in 1994 (see McKinley, “The Legacy of Rwanda Violence”) are called “enfants mauvais souvenir,” or children of bad memory, which may capture something of the sentiments, too, from the Caribbean. We also have this tragic account from the chronicler Girolamo Benzioni, quoted in Samuel M. Wilson, "), _c('em', [_vm._v("Hispaniola: Caribbean Chiefdoms in the Age of Columbus")]), _vm._v(" (Tuscaloosa: University of Alabama Press, 1990), 97, of the situation on Hispaniola in the late fifteenth century, which may shed light on the possible abandonment of infants witnessed by Cuneo: “The women, with the juice of a certain herb, dissipated their pregnancy, in order not to produce children, and then following the example of their husbands, hung themselves.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not16"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not16"
    }
  }, [_vm._v("16")]), _vm._v(". Quoted in Sale, "), _c('em', [_vm._v("The Conquest of Paradise,")]), _vm._v(" 139–40. As Sam Wilson, "), _c('em', [_vm._v("Hispaniola,")]), _vm._v(" 83–84, notes, the accounts of this period reflected some factional rivalry within the Spanish camp, which may have led to exaggerated descriptions of events at La Navidad, such as Peter Martyr’s statement: “Incapable of moderation in their acts of injustice, they carried off the women of the islanders under the very eyes of their brothers and their husbands; given over to violence and thieving, they had profoundly vexed the natives”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not17"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not17"
    }
  }, [_vm._v("17")]), _vm._v(". See Michael Taussig’s discussion of twentieth-century photographs of naked indigenous women of South America as a form of “cannibalism in another mode” in "), _c('em', [_vm._v("Shamanism, Colonialism, and the Wild Man: A Study in Terror and Healing")]), _vm._v(" (Chicago: University of Chicago Press, 1987), 114–15.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not18"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not18"
    }
  }, [_vm._v("18")]), _vm._v(". Todorov "), _c('em', [_vm._v("(The Morals of History,")]), _vm._v(" 103–7) contrasts the writings of these two men.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not19"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not19"
    }
  }, [_vm._v("19")]), _vm._v(". Sale, "), _c('em', [_vm._v("The Conquest of Paradise,")]), _vm._v(" 140. Iris M. Zavala recalls how the Muslims “had been frequently represented as licentious, lascivious, and having body "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("odors.” “Representing the Colonial Subject,” in "), _c('em', [_vm._v("1492–1992: Re/Discovering Colonial Writing,")]), _vm._v(" Hispanic Issues, no. 4, edited by René Jara and Nicholas Spadaccini (Minneapolis: University of Minnesota Press, 1989), 330. Magnus Mörner, in "), _c('em', [_vm._v("Race Mixture in the History of Latin America")]), _vm._v(" (Boston: Little, Brown and Company, 1976), 21, reminds us of efforts on the part of the indigenous men of the Antilles “to hide their women from the white strangers,” suggesting that relations were unwanted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not20"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not20"
    }
  }, [_vm._v("20")]), _vm._v(". Montrose (“The Work of Gender,” 181) quotes the passage about the women’s sexual torture of their husbands’ penises. Todorov "), _c('em', [_vm._v("(The Morals of History,")]), _vm._v(" 105) quotes a French translator of 1855, who indicates how popular this story made Vespucci.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not21"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not21"
    }
  }, [_vm._v("21")]), _vm._v(". Todorov, "), _c('em', [_vm._v("The Morals of History,")]), _vm._v(" 105–9. Montrose (“The Work of Gender,” 180) quotes in full the text from Vespucci’s letter of 1504 that seems to describe this scene.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not22"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not22"
    }
  }, [_vm._v("22")]), _vm._v(". Antonello Gerbi, "), _c('em', [_vm._v("Nature in the New World: From Christopher Columbus to Gonzalo Fernández de Oviedo")]), _vm._v(" (Pittsburgh: University of Pittsburgh Press, 1985), 350–51.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not23"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not23"
    }
  }, [_vm._v("23")]), _vm._v(". Ramón Gutiérrez, "), _c('em', [_vm._v("When Jesus Came, the Corn Mothers Went Away: Marriage, Sexuality, and Power in New Mexico, 1500–1846")]), _vm._v(" (Stanford, Calif.: Stanford University Press, 1991), 17, 45. Gutiérrez’s use of the term “libidinous” may reflect more of the European point of view than the indigenous. Many modern observers have been greatly influenced by European male writings on the sexuality of the indigenous women of this hemisphere. Even Hilde Krueger, a woman publishing in New York in the 1940s, shockingly calls the “young Indian women, so animal-like in their approach to sex” and suggests that they “looked upon the Spaniard as a kind of god.” She adds that the “mutual feeling of strangeness … must have lent the erotic experience entirely new facets and an emotional aspect we can only faintly imagine.” Quoted by Frances Karttunen, "), _c('em', [_vm._v("Between Worlds: Interpreters, Guides, and Survivors")]), _vm._v(" (New Brunswick, N.J.: Rutgers University Press, 1994), 3.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not24"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not24"
    }
  }, [_vm._v("24")]), _vm._v(". Many modern observers have apologized for sexual assault in the conquest of the Americas by saying that, after long voyages and with so few European women present in the early years, the invaders were inevitably scratching a sexual itch. Later, as colonial society began to resemble the metropolis and Iberian women came over in large numbers, rape diminished. However, the evolution from conquest to full-blown settlement entailed myriad social and political transformations, besides the growing presence of European women, that likely affected the frequency of sexual assault. Sex-ratio proponents slight the role of rape as a tool both for terrorizing initially and for maintaining control over time. Further, the results of recent sex-ratio research have diminished rather than strengthened its relationship to the frequency of rape. See Hartmann and Ross, “Comment on ’On Writing the History of Rape,’” 932–33. Peggy Reeves Sanday asserts flatly "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v("that “Rape is not an instinct triggered by celibacy” in “The Socio-Cultural Context of Rape: A Cross-Cultural Study,” "), _c('em', [_vm._v("Journal of Social Issues 37.4")]), _vm._v(" (1981): 25.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not25"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not25"
    }
  }, [_vm._v("25")]), _vm._v(". Gutiérrez, "), _c('em', [_vm._v("When Jesus Came,")]), _vm._v(" 51.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not26"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not26"
    }
  }, [_vm._v("26")]), _vm._v(". Quoted in John Hemming, "), _c('em', [_vm._v("Red Gold: The Conquest of the Brazilian Indians, 1500–1760")]), _vm._v(" (Cambridge: Harvard University Press, 1978), 17.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not27"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not27"
    }
  }, [_vm._v("27")]), _vm._v(". Quoted in Hemming, "), _c('em', [_vm._v("Red Gold,")]), _vm._v(" 3–4.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not28"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not28"
    }
  }, [_vm._v("28")]), _vm._v(". Enrique Dussel interprets the relationship this way: “In satisfying a frequently sadistic voluptuousness, Spaniards vented their purely masculine libido through the erotic subjugation of the Other as Indian woman.” "), _c('em', [_vm._v("The Invention of the Americas: Eclipse of “the Other” and the Myth of Modernity,")]), _vm._v(" translated by Michael D. Barber (New York: Continuum, 1995), 46.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not29"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not29"
    }
  }, [_vm._v("29")]), _vm._v(". Quoted in Hemming, "), _c('em', [_vm._v("Red Gold,")]), _vm._v(" 43–44.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not30"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not30"
    }
  }, [_vm._v("30")]), _vm._v(". Quoted in Hemming, "), _c('em', [_vm._v("Red Gold,")]), _vm._v(" 17.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not31"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not31"
    }
  }, [_vm._v("31")]), _vm._v(". See Claudio Esteva-Fabregat, "), _c('em', [_vm._v("Mestizaje in Ibero-America")]), _vm._v(" (Tucson: University of Arizona Press, 1995), 157. Of course, clergy were not guiltless of seducing indigenous women and siring mixed-heritage offspring. The indigenous critique of Spanish colonization in Peru, apparently written by Felipe Guamán Poma de Ayala, includes an illustration of children sired by priests (reproduced in Mörner, "), _c('em', [_vm._v("Race Mixture,")]), _vm._v(" xiv). In New Mexico, Fray Nicolás de Freitas noted that many friars had concubines and “all the pueblos are full of friars’ children.” Quoted in Gutiérrez, "), _c('em', [_vm._v("When Jesus Came, 123.")]), _vm._v(" Gutiérrez (124–25) elaborates on charges made by indigenous women against priests and various priests’ admissions of guilt, including a case in which a friar had forcibly raped “a woman, splitting her throat, and burying her in his cell.” In an indigenous petition to have a priest removed from a pueblo in Jalisco in 1611, Juan Vicente complained that the priest had tried to force himself on the man’s daughter when she went to sweep the church one evening. “She would not let him,” Juan Vicente wrote (but in his original language, Náhuatl), “and there inside the church he beat her.” See "), _c('em', [_vm._v("Beyond the Codices,")]), _vm._v(" edited by Arthur J. O. Anderson, Frances Berdan, and James Lockhart (Los Angeles: UCLA Latin American Center, 1976), 170–74. See also Robert Haskett, “‘Not a Pastor but a Wolf’: Indigenous Clergy Relations in Early Cuerna vaca and Taxco,” "), _c('em', [_vm._v("The Americas")]), _vm._v(" 50.3 (1994): 318–22.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not32"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not32"
    }
  }, [_vm._v("32")]), _vm._v(". Mörner, "), _c('em', [_vm._v("Race Mixture,")]), _vm._v(" 23.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not33"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not33"
    }
  }, [_vm._v("33")]), _vm._v(". See Anne J. Cruz and Mary Elizabeth Perry, “Culture and Control in Counter-Reformation Spain,” in "), _c('em', [_vm._v("Culture and Control in Counter-Reformation Spain,")]), _vm._v(" Hispanic Issues, no. 7, edited by Anne J. Cruz and Mary Elizabeth Perry (Minneapolis: University of Minnesota Press, 1992), ix-xxiii.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not34"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not34"
    }
  }, [_vm._v("34")]), _vm._v(". Hurtado, "), _c('em', [_vm._v("Indian Survival on the California Frontier, 25.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not35"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not35"
    }
  }, [_vm._v("35")]), _vm._v(". Quoted in Esteva-Fabregat, "), _c('em', [_vm._v("Mestizaje in Ibero-America,")]), _vm._v(" 157.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not36"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not36"
    }
  }, [_vm._v("36")]), _vm._v(". Eugene Korth, "), _c('em', [_vm._v("The Spanish Policy in Colonial Chile: The Struggle for Justice, 1535–1700")]), _vm._v(" (Stanford, Calif.: Stanford University Press, 1968), 217–19.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "id": "ich01not37"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not37"
    }
  }, [_vm._v("37")]), _vm._v(". Diane Wolfthal, “‘A Hue and a Cry’: Medieval Rape Imagery and Its Transformation,” "), _c('em', [_vm._v("Art Bulletin")]), _vm._v(" 75.1 (1993): 39–40.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not38"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not38"
    }
  }, [_vm._v("38")]), _vm._v(". One difference was that, over time, a greater number of permanent relationships between Spanish men and indigenous women would form in these central areas as the European presence increased.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not39"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not39"
    }
  }, [_vm._v("39")]), _vm._v(". Bartolomé de Las Casas, "), _c('em', [_vm._v("The Devastation of the Indies: A Brief Account")]), _vm._v(" (Baltimore: Johns Hopkins University Press, 1992), 2, 4, 77.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not40"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not40"
    }
  }, [_vm._v("40")]), _vm._v(". Tzvetan Todorov also reproduces passages from Las Casas which he sees as possibly realistic eyewitness accounts. In one, "), _c('em', [_vm._v("The Conquest of America: The Question of the Other,")]), _vm._v(" translated by Richard Howard (New York: Harper Torchbooks, 1987), 139, a Dominican ecclesiastic tells about some overseers in the gold mines in the Caribbean in 1519 who regularly violated married women and “maidens,” while sending the indigenous men out to the fields, even going so far as to tie one man up and throw him “under the bed like a dog, before the foreman lay down, directly over him, with his wife.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not41"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not41"
    }
  }, [_vm._v("41")]), _vm._v(". Bernal Díaz, "), _c('em', [_vm._v("The Conquest of New Spain")]), _vm._v(" (Harmondsworth, England: Penguin, 1963), 330–31.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not42"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not42"
    }
  }, [_vm._v("42")]), _vm._v(". See Esteva-Fabregat, "), _c('em', [_vm._v("Mestizaje in Ibero-America,")]), _vm._v(" 157–58.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not43"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not43"
    }
  }, [_vm._v("43")]), _vm._v(". "), _c('em', [_vm._v("We People Here: Náhuatl Accounts of the Conquest of Mexico,")]), _vm._v(" Reportorium Columbianum, no. 1, edited and translated by James Lockhart (Berkeley: University of California Press, 1993), 248. A Spanish preference for fair skin seems also to be indicated by Gonzalo Fernández de Oviedo’s reference to the efforts of indigenous women on Hispaniola in the sixteenth century to bleach their skin in order to attract alliances with colonists. See Kathleen A. Deagan, “Spanish-Indian Interaction in Sixteenth-Century Florida and Hispaniola,” in "), _c('em', [_vm._v("Cultures in Contact: The Impact of European Contacts on Native American Cultural Institutions, A.D. 1000–1800,")]), _vm._v(" Anthropological Society of Washington Series, edited by William W. Fitzhugh (Washington, D.C.: Smithsonian Institution Press, 1985), 306.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not44"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not44"
    }
  }, [_vm._v("44")]), _vm._v(". Díaz, "), _c('em', [_vm._v("The Conquest of New Spain,")]), _vm._v(" 352.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not45"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not45"
    }
  }, [_vm._v("45")]), _vm._v(". Marcelo Díaz de Salas and Luis Reyes García, “Testimonio de la Fundación de Santo Tomás Ajusco,” "), _c('em', [_vm._v("Tlalocan")]), _vm._v(" 6.3 (1970): 196.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not46"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not46"
    }
  }, [_vm._v("46")]), _vm._v(". Díaz, "), _c('em', [_vm._v("The Conquest of New Spain,")]), _vm._v(" 176. Elsewhere (125), Díaz also speaks of a doña Francisca as being “very beautiful, for an Indian.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not47"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not47"
    }
  }, [_vm._v("47")]), _vm._v(". Díaz, "), _c('em', [_vm._v("The Conquest of New Spain,")]), _vm._v(" 80–82.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not48"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not48"
    }
  }, [_vm._v("48")]), _vm._v(". Karttunen, "), _c('em', [_vm._v("Between Worlds,")]), _vm._v(" 22.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not49"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not49"
    }
  }, [_vm._v("49")]), _vm._v(". Díaz, "), _c('em', [_vm._v("The Conquest of New Spain,")]), _vm._v(" 121, 125. Díaz also quotes two caciques of Tlaxcala who speak of giving the Spaniards women “so that we may have kinship with their children” (154).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not50"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not50"
    }
  }, [_vm._v("50")]), _vm._v(". Díaz de Salas and Reyes, “Testimonio de la Fundación de Santo Tomás Ajusco,” 199.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('a', {
    attrs: {
      "id": "ich01not51"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not51"
    }
  }, [_vm._v("51")]), _vm._v(". "), _c('em', [_vm._v("Relación de las ceremonias y ritos y población y gobierno de los indios de la Provincia de Michoacán (1541), Reproducción facsímil del Ms. ç. IV. 5. del El Escorial,")]), _vm._v(" edited by José Tudela, with a preliminary study by Paul Kirchoff (Madrid: Aguilar, 1956), 256.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not52"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not52"
    }
  }, [_vm._v("52")]), _vm._v(". Díaz, "), _c('em', [_vm._v("The Conquest of New Spain,")]), _vm._v(" 121.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not53"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not53"
    }
  }, [_vm._v("53")]), _vm._v(". Steve Stern suggests that, in colonial Peru, the indigenous women may have had little say in the decision that they be given by their fathers in alliances to Spanish men. He also considers the possibility that they may have found “marriage or informal conjugal relations with outsiders” attractive, in order to acquire property or escape taxation burdens in their communities. The indigenous writer Felipe Guamán Poma de Ayala complained in the early seventeenth century that indigenous women “no longer love Indians but rather Spaniards, and they become big whores.” This shows resentment and exaggeration but still reflects what Steve Stern calls “a very real social pattern.” See Steve J. Stern, "), _c('em', [_vm._v("Peru’s Indian Peoples and the Challenge of Spanish Conquest: Huamanga to 1640")]), _vm._v(" (Madison: University of Wisconsin Press, 1982), 170.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not54"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not54"
    }
  }, [_vm._v("54")]), _vm._v(". Hemming, "), _c('em', [_vm._v("Red Gold,")]), _vm._v(" 43–44. There are other, occasional attestations of indigenous women’s sometimes positive views on sexual relations with the foreigners, relations which their own leaders encouraged. For instance, in Florida in the 1560s an indigenous leader offered his sister to the Spanish conqueror Pedro Menéndez de Avilés and, after a supposed debate about what should be the appropriate action on Menéndez’s part, the “captains” (his men or the indigenous leaders?) explained to her that it would be good for Menéndez to “sleep with her, for this would be a great beginning to their trusting him and the other Christians.” Supposedly, “in the morning she arose very joyful and the Christian women who spoke to her said that she was very much pleased.” Such a response on her part, if not a European invention or something she pretended, could mean that she was pleased with herself for fulfilling a role expected of her by either her own people, the new power holders, or both. See "), _c('em', [_vm._v("New American World: A Documentary History of North America to 1612, 5")]), _vm._v(" vols., edited by David B. Quinn (New York: Arno Press and Hector Bye, 1979), 2:484.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not55"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not55"
    }
  }, [_vm._v("55")]), _vm._v(". Stern, "), _c('em', [_vm._v("Peru’s Indian Peoples,")]), _vm._v(" 171–73.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not56"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not56"
    }
  }, [_vm._v("56")]), _vm._v(". Díaz, "), _c('em', [_vm._v("The Conquest of New Spain,")]), _vm._v(" 409. It was self-serving of Díaz to recount this story, but it may be true. He also tells how Cortés’s interpreter doña Marina said that “she would rather serve her husband and Cortés than anything else in the world” (86).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not57"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not57"
    }
  }, [_vm._v("57")]), _vm._v(". Padden "), _c('em', [_vm._v("(The Hummingbird and the Hawk,")]), _vm._v(" 232) describes the “tragic origin” of the first mixed-heritage offspring from the Spanish conquest of Mexico, who faced considerable rejection and hostility and supposedly created such havoc that they caught the attention of the first bishop sent to the region.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not58"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not58"
    }
  }, [_vm._v("58")]), _vm._v(". Mörner, "), _c('em', [_vm._v("Race Mixture, 27.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "ich01not59"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not59"
    }
  }, [_vm._v("59")]), _vm._v(". "), _c('em', [_vm._v("New Iberian World: A Documentary History of the Discovery and Settlement of Latin America to the Early 17th Century, 5")]), _vm._v(" vols., edited by John H. Parry and Robert G. Keith (New York: Times Books, 1984), 2:349–53.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not60"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not60"
    }
  }, [_vm._v("60")]), _vm._v(". Susan Brownmiller, "), _c('em', [_vm._v("Against Our Will: Men, Women, and Rape")]), _vm._v(" (New York: Bantam, 1975), 313.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not61"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not61"
    }
  }, [_vm._v("61")]), _vm._v(". Mörner, "), _c('em', [_vm._v("Race Mixture,")]), _vm._v(" 25.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not62"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not62"
    }
  }, [_vm._v("62")]), _vm._v(". See Octavio Paz’s essay “Sons of La Malinche,” in his book, "), _c('em', [_vm._v("The Labyrinth of Solitude: Life and Thought in Mexico")]), _vm._v(" (New York: Grove Press, 1961), for his exploration of the psychological trauma of being sons of “la chingada.” Novelist Carlos Fuentes’s narratives (quoted, for example, in Dussel, "), _c('em', [_vm._v("The Invention of the Americas,")]), _vm._v(" 47) also eloquently capture the struggle of the mestizo child.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not63"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not63"
    }
  }, [_vm._v("63")]), _vm._v(". Herren, "), _c('em', [_vm._v("La conquista erótica,")]), _vm._v(" 256 (the translation is mine).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not64"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not64"
    }
  }, [_vm._v("64")]), _vm._v(". Quoted in Montrose, “The Work of Gender,” 187. Note how Ralegh, not unlike his Mediterranean counterparts, refers to the indigenous women as possessions of the indigenous men. Northern European men were not guiltless of behaviors they delighted in attributing to the Spanish. Captain John Sutter of New Helvetia colony in Mexican California allegedly had a special room next to his chambers where a “large number of Indian girls … were constantly at his beck and call,” and he had sex with some as young as ten years old. In Oregon, when one of Jedediah Smith’s men raped an Umpqua woman in the late 1820s, the tribe killed most of Smith’s men and stole their horses and pelts in retaliation. See Hurtado, "), _c('em', [_vm._v("Indian Survival on the California Frontier,")]), _vm._v(" 63, 42. Susan Brownmiller "), _c('em', [_vm._v("(Against Our Will,")]), _vm._v(" 150) suspects that rape was “a casual by-product of the move westward and The Great Frontier,” where the “rape of a ‘squaw’ by white men was not deemed important. The Indian woman gave her testimony to no one; it was never solicited, except perhaps orally within her tribe.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not65"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not65"
    }
  }, [_vm._v("65")]), _vm._v(". Cruz and Perry, “Culture and Control in Counter-Reformation Spain,” xviii-xix.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not66"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not66"
    }
  }, [_vm._v("66")]), _vm._v(". Wolfthal, “‘A Hue and a Cry,’” 57, 61–62.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not67"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not67"
    }
  }, [_vm._v("67")]), _vm._v(". "), _c('em', [_vm._v("Against Our Will,")]), _vm._v(" 35.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not68"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not68"
    }
  }, [_vm._v("68")]), _vm._v(". Bernal Díaz "), _c('em', [_vm._v("(The Conquest of New Spain,")]), _vm._v(" 140–41) discusses the disappointing calculation of the shares for the captains and soldiers after the entrada that gained the Spaniards control of Mexico.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not69"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not69"
    }
  }, [_vm._v("69")]), _vm._v(". James Lockhart, "), _c('em', [_vm._v("Spanish Peru, 1532–1560: A Colonial Society")]), _vm._v(" (Madison: University of Wisconsin Press, 1968), 138.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not70"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not70"
    }
  }, [_vm._v("70")]), _vm._v(". Lyle N. McAlister, "), _c('em', [_vm._v("Spain and Portugal in the New World, 1492–1700,")]), _vm._v(" Europe and the World in the Age of Expansion, no. 3 (Minneapolis: University of Minnesota Press, 1984), 91.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not71"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not71"
    }
  }, [_vm._v("71")]), _vm._v(". Zavala, “Representing the Colonial Subject,” 326, 333.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not72"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not72"
    }
  }, [_vm._v("72")]), _vm._v(". The monarch declared intermarriage permissible in a pronouncement of 1501. The governor of Santo Domingo, Hispaniola, encouraged intermarriage in "), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _vm._v("1503 (Mörner, "), _c('em', [_vm._v("Race Mixture,")]), _vm._v(" 25–26). Pronouncements in favor of marriage were also included, for example, in the Laws of Burgos of 1512 (Deagan, “Spanish-Indian Interaction,” 298). Still, only about 10 percent of Spanish men in Santo Domingo in 1514 were married to native women; concubinage was the norm (Mörner, "), _c('em', [_vm._v("Race Mixture,")]), _vm._v(" 25–26).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not73"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not73"
    }
  }, [_vm._v("73")]), _vm._v(". Note the instructions given Christopher Columbus in 1493, “that the Indians be treated with kindness,” which, in the wake of abuses, evolved quickly into much more specific orders "), _c('em', [_vm._v("(1492–1992: Re/Discovering Colonial Writing,")]), _vm._v(" 387). In 1501, for instance, the instructions prohibited “Christians living in the Indies to take the wives or sons or daughters of the Indians or do any other harm or damage to their persons or their possessions” "), _c('em', [_vm._v("(New Iberian World,")]), _vm._v(" 2:261). Again, in 1510, Hernando Cortés was told to prevent “any of the Spanish Christians of your company [from engaging] in an excess or casual coitus with any woman outside of our law, because it is a very odious sin against God” and urging that “there should not be scandal… nor in any way or manner should they dare to enter their houses or trifle with their women nor should they take them, nor approach them, nor speak to them, nor say or do anything else that might be presumed to cause any annoyance” "), _c('em', [_vm._v("(1492–1992: Re/Discovering Colonial Writing,")]), _vm._v(" 402, 410). The persisting need for such pronouncements suggests the nightmare lived on, but it also shows an official effort to curb such behavior.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not74"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not74"
    }
  }, [_vm._v("74")]), _vm._v(". McAlister, "), _c('em', [_vm._v("Spain and Portugal in the New World,")]), _vm._v(" 91. King Ferdinand ordered that items given to indigenous peoples must have a least a third of the value of the item obtained from them: the trading advantage had to have limits. Rescate practices surely exceeded the limits, although some captains kept trying to remind their men of such rulings. Columbus objected to what he saw as unfair trading with the Taínos, for instance. See James Axtell, "), _c('em', [_vm._v("Imagining the Other: First Encounters in North America")]), _vm._v(" (Washington, D.C.: American Historical Association, 1991), 27.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not75"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not75"
    }
  }, [_vm._v("75")]), _vm._v(". Quoted in Hemming, "), _c('em', [_vm._v("Red Gold,")]), _vm._v(" 41.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not76"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not76"
    }
  }, [_vm._v("76")]), _vm._v(". Claudio Esteva-Fabregat "), _c('em', [_vm._v("(Mestizaje in Ibero-America,")]), _vm._v(" 120, 123) calls the seizure of women a “predatory excess,” “a constant,” and a “habitual process within the very strategy of war.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not77"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not77"
    }
  }, [_vm._v("77")]), _vm._v(". There was a formal ceremony in which a legal (in European terms) document, called a "), _c('em', [_vm._v("requerimiento")]), _vm._v(" (requirement), was read to the indigenous peoples about their pending colonization. If they resisted, the would lose their liberty and property. See Lewis Hanke, "), _c('em', [_vm._v("The Spanish Struggle for Justice in the Conquest of America")]), _vm._v(" (Boston: Little, Brown and Company, 1965), 31–36. On “just war” see also Padden, "), _c('em', [_vm._v("The Hummingbird and the Hawk,")]), _vm._v(" 136.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ich01not78"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01not78"
    }
  }, [_vm._v("78")]), _vm._v(". Venereal disease can be another vile legacy of sexual coercion and assault. “Syphilis was especially devastating” for the indigenous population of California, says Albert Hurtado "), _c('em', [_vm._v("(Indian Survival on the California Frontier,")]), _vm._v(" 25), “killing people outright or weakening their defenses so much that other diseases killed "), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _vm._v("them. It was particularly hard on women in childbirth, killing both mother and child.” The men in the conquering expedition of Hernando Cortés in Mexico complained as they descended a pyramid that their “thighs pained them” because they were “suffering from pustules or running sores,” a possible indication of venereal disease (Díaz, "), _c('em', [_vm._v("The Conquest of New Spain,")]), _vm._v(" 238). They called venereal disease “mal de mujeres” (illness from women), revealing their one-sided view. See Padden, "), _c('em', [_vm._v("The Hummingbird and the Hawk,")]), _vm._v(" 230.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c62556b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 84
// module chunks = 0